<template>
  <div>
    <v-card outlined tile class="mt-2">
      <v-card-text class="pa-0">
        <v-data-table
          class="page-table"
          :headers="headers"
          :items="table"
          :items-per-page="10"
          :loading="isLoading"
        >
          <template v-slot:top>
            <Header @change="type = $event"></Header>
          </template>
          <template v-slot:item.status="{ item }">
            {{
            item.status === "no" ? "Not Rented" : "Rented"
            }}
          </template>
          <template v-slot:item.action="{ item }">
            <template v-if="item.check !== 'unsure'">
              <Update :item="item"></Update>
              <Delete :item="item"></Delete>
            </template>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Header from "./Header";
import Delete from "./Delete";
import Update from "./Update";
import { db } from "../assets/js/firebase";

export default {
  components: {
    Header,
    Update,
    Delete
  },
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: "Name",
          align: "start",
          divider: true,
          sortable: true,
          value: "name"
        },
        {
          text: "Listing Date",
          align: "start",
          divider: true,
          sortable: true,
          value: "date"
        },
        {
          text: "Status",
          align: "start",
          divider: true,
          sortable: false,
          value: "status"
        },
        {
          text: "Days On Market",
          align: "start",
          divider: true,
          sortable: false,
          value: "days"
        },
        {
          text: "Applications",
          align: "start",
          divider: true,
          sortable: false,
          value: "count"
        },
        {
          text: "Action",
          align: "center",
          width: "150px",
          sortable: true,
          value: "action"
        }
      ],
      type: "no"
    };
  },
  computed: {
    table() {
      let list = [];
      let table = this.$store.getters.table;
      table.forEach(item => {
        let { status } = item;
        if (status === this.type || this.type === "all") {
          list.push(item);
        }
      });
      return list;
    }
  },
  methods: {
    import() {
      let lists = [];
      lists.forEach(async ({ name, date }) => {
        name = name.trim();
        let check = name.toLowerCase();
        let doc = { name, date, check, count: 0, status: "no" };
        await db.child("property").push(doc);
      });
    }
  },
  mounted() {}
};
</script>
